import { render, staticRenderFns } from "./PatientDetailPolicies.vue?vue&type=template&id=2ca42abb&scoped=true"
import script from "./PatientDetailPolicies.vue?vue&type=script&lang=js"
export * from "./PatientDetailPolicies.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailPolicies.vue?vue&type=style&index=0&id=2ca42abb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca42abb",
  null
  
)

export default component.exports